module.exports = "/assets/data/b13b8287fa01309e7fc6f140f6033d37-BD20.data.json";